"use client"
import Button from "@/components/CommonComponent/button"
import NewsLetter from "@/components/serviceComponent/newsLetter"
import { BASE_URL } from "@/util/api"
import { Pagination } from "antd"
import axios from "axios"
import { ChevronLeft, ChevronRight } from "lucide-react"
import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/navigation"
import type React from "react"
import { useEffect, useRef, useState } from "react"
import toast from "react-hot-toast"
import { CiClock2 } from "react-icons/ci"
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"

interface BlogsProps {
  currentPage?: number
}

const Blogs = ({ currentPage = 1 }: BlogsProps) => {
  const [blogs, setBlogs] = useState<any>(null)
  const [allBlogs, setAllBlogs] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState("")
  const [pages, setPages] = useState<number>(0)
  const [pageState, setPageState] = useState<number>(currentPage)
  const [recentblogs, setrecentblogs] = useState<any>()
  const menuRef = useRef<HTMLUListElement>(null)
  const [category, setcategory] = useState<any>(null)
  const [featured, setfeatured] = useState<any>([])
  const sectionRef = useRef<HTMLDivElement | null>(null)
  const [recentnews, setrecentnews] = useState<any>()
  const [isPageChanging, setIsPageChanging] = useState(false)

  const router = useRouter()

  const fetchBlogs = async (page = 1, query = "") => {
    try {
      const url = query ? `${BASE_URL}blogs/?page=${page}&search=${query}` : `${BASE_URL}blogs/?page=${page}`
      const response = await axios.get(url)
      setBlogs(response.data)
      setAllBlogs(response.data.results.blogs)
      const totalPages = Math.ceil(response.data.count / 10)
      setPages(totalPages)

      if (isPageChanging) {
        setTimeout(() => {
          sectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
          setIsPageChanging(false)
        }, 100)
      }
    } catch (error: any) {
      console.log(error)
      setIsPageChanging(false)
    }
  }

  const fetchrecentBlogs = async (page = 1) => {
    try {
      const response = await axios.get(`${BASE_URL}blogs/?page=1`)
      setrecentblogs(response?.data?.results?.recent_blogs)
      setfeatured(response?.data?.results?.favourite_blogs)
      setcategory(response?.data?.results?.categories)
      setrecentnews(response?.data?.results?.recent_news)
    } catch (error: any) {
      // Handle error
    }
  }

  useEffect(() => {
    setPageState(currentPage)
    fetchBlogs(currentPage, searchQuery)
  }, [currentPage, searchQuery])

  useEffect(() => {
    fetchrecentBlogs()
  }, [])

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  const handlePageChange = (page: number) => {
    if (page !== pageState) {
      setIsPageChanging(true)
      if (page === 1) {
        router.push("/blog", { scroll: false })
        
      } else {
        router.push(`/blog/page/${page}`, { scroll: false })
        
      }
      setPageState(page)
    }
  }

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const scrollMenu = (direction: "left" | "right") => {
    if (menuRef.current) {
      menuRef.current.scrollBy({
        left: direction === "left" ? -250 : 250,
        behavior: "smooth",
      })
    }
  }

  const checkScrollability = () => {
    if (menuRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = menuRef.current
      setCanScrollLeft(scrollLeft > 0)
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      checkScrollability()
    }, 100)

    menuRef.current?.addEventListener("scroll", checkScrollability)
    window.addEventListener("resize", checkScrollability)

    return () => {
      clearTimeout(timer)
      menuRef.current?.removeEventListener("scroll", checkScrollability)
      window.removeEventListener("resize", checkScrollability)
    }
  }, [blogs?.results?.category])

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const [email, setEmail] = useState("")
  const [error, setError] = useState("")

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setEmail(value)
    setError(emailRegex.test(value) ? "" : "Invalid email format")
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email || !emailRegex.test(email)) {
      setError("Invalid email format")
      return
    }
    try {
      await axios.post(`${BASE_URL}subscription/`, { email })
      toast.success("Subscribed successfully")
      setEmail("")
      setError("")
    } catch (error: any) {
      toast.error(error?.response?.data?.email || "Something went wrong!")
    }
  }

  return (
    <div>
      <div className="w-full relative">
        <div className={` top-10 lg:top-4 z-50 pt-3 sm:pt-7  ${scrolled ? "" : "bg-[#DFF1F9]"}`}>
          {blogs?.results?.category && blogs?.results?.category.length > 0 && (
            <div className="top-16 sticky z-20 w-fit max-w-[95%] lg:max-w-[75%] xl:w-[60%] 2xl:max-w-[55%] mx-auto mt-4 ">
              <button
                onClick={() => scrollMenu("left")}
                className={`absolute left-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 transition-opacity duration-300 ${
                  canScrollLeft ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
                aria-hidden={!canScrollLeft}
              >
                <ChevronLeft size={24} />
              </button>
              <div className="bg-white text-homeblack sticky flex top-16 z-40 shadow p-4 lg:px-10 rounded-full overflow-hidden">
                <ul
                  ref={menuRef}
                  className="flex gap-6 mx-10 w-full overflow-x-auto scroll-smooth whitespace-nowrap no-scrollbar"
                  style={{ scrollbarWidth: "none" }}
                  onScroll={checkScrollability}
                >
                  {blogs?.results?.category.map((section: any, index: number) => (
                    <a
                      key={index}
                      href={`/blog/${section?.category_slug}`}
                      className="relative cursor-pointer font-medium transition-colors duration-300 group"
                    >
                      {section?.name}
                      <span className="absolute left-0 -bottom-1 bg-pink h-[2px] w-0 group-hover:w-full transition-all duration-300"></span>
                    </a>
                  ))}
                </ul>
              </div>
              <button
                onClick={() => scrollMenu("right")}
                className={`absolute right-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 transition-opacity duration-300 ${
                  canScrollRight ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
                aria-hidden={!canScrollRight}
              >
                <ChevronRight size={24} />
              </button>
            </div>
          )}
        </div>
        <div className="w-full h-auto py-12 2xl:py-8 px-4 bg-[#DFF1F9] flex flex-col items-center justify-center relative overflow-hidden">
          <img
            src="/blog/blog-banner-left.png"
            alt="blog-banner Left"
            className="hidden md:block absolute bottom-0 left-0 2xl:left-40 w-28 sm:w-36 md:w-44 lg:w-52 xl:w-64 2xl:w-[18rem] object-contain pointer-events-none select-none"
          />

          <img
            src="/blog/blog-banner-right.png"
            alt="blog-banner Right"
            className="hidden md:block absolute bottom-0 right-0 2xl:right-40 w-28 sm:w-36 md:w-44 lg:w-52 xl:w-64 2xl:w-[18rem] object-contain pointer-events-none select-none"
          />

          <div className="relative z-10 flex flex-col justify-center items-center text-center space-y-4 min-h-[40vh] mx-auto px-4 max-w-[52rem]">
            <h1 className="text-[#0A6FA0] text-[28px] sm:text-[32px] lg:text-[25px] 2xl:text-[48px] font-bold leading-tight">
              Drive Growth with Expert Search Marketing Insights
            </h1>
            <p className="text-base sm:text-lg text-homegrey">
              Discover expert strategies, practical tips, and industry insights to elevate your Search marketing efforts
              and drive measurable results for your business.
            </p>
            <form onSubmit={handleSubmit} className="my-4 flex flex-col sm:flex-row items-center gap-2">
              <div className="flex flex-col">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  placeholder="E-mail Address"
                  className="sm:w-64 px-4 py-2 rounded-md border border-gray-300 text-black focus:outline-none"
                  required
                />
                {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
              </div>
              <button
                type="submit"
                className="px-6 py-2 bg-white text-pink hover:bg-pink hover:text-white font-semibold rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!!error}
              >
                Subscribe Now
              </button>
            </form>
          </div>
        </div>

        <div className="mx-auto py-5">
          <div className="w-full gap-5 relative h-full  mx-auto lg:w-[95%] 2xl:w-[80%] px-4 text-white mb-8 lg:mb-32">
            <div className=" w-full leading-tight rounded-lg text-textGrey mt-5 text-[18px] ">
              <div className="text-[16px]  flex items-center justify-start gap-2 flex-wrap">
                <span className="text-blue">
                  <Link href="/">Home</Link>
                </span>
                <span>
                  <MdOutlineKeyboardDoubleArrowRight />
                </span>
                <span className=" max-w-[150px] text-blue sm:max-w-[200px] lg:max-w-[250px]">
                  <Link href="/blog/">Blog</Link>
                </span>
                {pageState > 1 && (
                  <>
                    <span>
                      <MdOutlineKeyboardDoubleArrowRight />
                    </span>
                    <span className="text-textGrey">Page {pageState}</span>
                  </>
                )}
              </div>
            </div>
            <div className="w-full ">
              <div>
                <h2 className="text-homeblack border-b-2 border-pink w-fit mt-8">Featured Blog</h2>
                {featured && featured.length > 0 ? (
                  <div className="flex lg:flex-row  flex-col gap-5 h-full">
                    <div className="bg-white border-[1px] group hover:bg-lightblue border-slate-200 rounded-lg my-4 lg:w-[45%] 2xl:w-[55%] p-4 h-inherit  flex flex-col min-h-[370px]  sm:text-left items-start gap-2">
                      {featured[0]?.image && (
                        <Link href={`/blog/${featured[0]?.category?.category_slug}/${featured[0]?.slug_link}`}>
                          <Image
                            src={featured[0]?.image || ""}
                            height={275}
                            unoptimized
                            width={420}
                            alt={featured[0]?.image_alt}
                            className="w-full object-cover rounded"
                          />
                        </Link>
                      )}
                      <div className="flex flex-col ml-4 mt-16 items-start gap-2">
                        <Link href={`/blog/${featured[0]?.category?.category_slug}/${featured[0]?.slug_link}`}>
                          <p className="text-[20px] font-bold group-hover:text-blue text-homeblack  blog-title">
                            {featured[0]?.title}
                          </p>
                        </Link>
                        <p className="text-homegrey text-[18px]">
                          <Link href={`/blog/${featured[0]?.category?.category_slug}`}>
                            <span className="text-blue font-medium">
                              {featured[0]?.category?.name || "Uncategorized"}
                            </span>{" "}
                          </Link>
                        </p>
                        <p className="text-[18px] text-textGrey blog-summary">
                          {featured[0]?.summary && featured[0]?.summary.length > 100
                            ? `${featured[0]?.summary.substring(0, 800)}...`
                            : featured[0]?.summary}
                        </p>
                        <div className="flex justify-between items-center mt-4 w-full text-homegrey">
                          <div className="flex items-center gap-2">
                            <CiClock2 className="w-4 h-4" />
                            {featured[0]?.reading_time && <span>{featured[0]?.reading_time} min read</span>}
                          </div>
                          <span>{featured[0]?.blog_date || ""}</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex  lg:w-[45%] flex-wrap gap-4 justify-between">
                      {featured?.slice(1, 5).map((elem: any, index: number) => (
                        <div key={index} className=" w-full sm:w-[48%] ">
                          <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                            <div className="bg-white border-[1px] group hover:bg-lightblue border-slate-200  rounded-lg my-4 w-full  flex flex-col min-h-[370px] p-4 sm:text-left items-start gap-2">
                              {elem?.image && (
                                <Image
                                  src={elem?.image || ""}
                                  height={145}
                                  unoptimized
                                  width={328}
                                  alt={elem?.image_alt}
                                  className="w-full object-cover rounded"
                                />
                              )}
                              <div className="flex flex-col ml-4 mt-5 items-start gap-2">
                                <p className="text-[18px] group-hover:text-blue text-homeblack font-bold blog-title">
                                  {elem?.title && elem?.title.length > 100
                                    ? `${elem?.title.substring(0, 30)}...`
                                    : elem?.title}
                                </p>
                                <p className="text-homegrey text-[16px]">
                                  <Link href={`/blog/${elem?.category?.category_slug}`}>
                                    <span className="text-blue font-medium">
                                      {elem?.category?.name || "Uncategorized"}
                                    </span>{" "}
                                  </Link>
                                </p>
                                <div className="flex justify-between items-center mt-4 w-full text-homegrey">
                                  <div className="flex items-center gap-2">
                                    <CiClock2 className="w-4 h-4" />
                                    {elem?.reading_time && <span>{elem?.reading_time} min read</span>}
                                  </div>
                                  <span>{elem?.blog_date || ""}</span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-center items-center min-h-screen">
                    <div className="loader "></div>
                  </div>
                )}
              </div>
              {allBlogs.length > 0 ? (
                <div className="" ref={sectionRef}>
                  <div className="border-b-2 border-pink w-fit mb-4 mt-20 text-black">
                    <h2 className="text-homeblack mb-1">Latest Blogs</h2>
                  </div>
                  <div className="w-full flex justify-between flex-wrap gap-3">
                    {allBlogs.length > 0 ? (
                      allBlogs.slice(0, 6).map((elem: any, index: number) => (
                        <Link
                          href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}
                          key={index}
                          className=" w-full xl:w-[49%]"
                        >
                          <div className="bg-white group border-b-[1.5px] border-slate-200   w-full p-4 flex sm:flex-row flex-col sm:text-left items-start gap-2">
                            {elem?.image && (
                              <Image
                                unoptimized
                                src={elem?.image || ""}
                                height={175}
                                width={328}
                                alt={elem?.image_alt}
                                className="w-full sm:w-[300px] min-h-[175px] xl:min-w-[328px]"
                              />
                            )}
                            <div className="flex flex-col ml-4 items-start gap-2">
                              <p className="text-[20px] text-homeblack group-hover:text-blue font-bold blog-title">
                                {elem?.title}
                              </p>
                              <p className="text-homegrey text-[18px]">
                                <Link href={`/blog/${elem?.category?.category_slug}`}>
                                  <span className="text-blue font-medium">
                                    {elem?.category?.name || "Uncategorized"}
                                  </span>{" "}
                                </Link>
                              </p>
                              <div className="flex justify-between items-center mt-4 w-full text-homegrey">
                                <div className="flex items-center gap-2">
                                  <CiClock2 className="w-4 h-4" />
                                  {elem?.reading_time && <span>{elem?.reading_time} min read</span>}
                                </div>
                                <span>{elem?.blog_date || ""}</span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <p>No blogs available.</p>
                    )}
                  </div>
                  <div className="flex w-full justify-center mt-3">
                    <Pagination
                      current={pageState}
                      total={blogs?.count || 0}
                      pageSize={10}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                    />
                  </div>
                </div>
              ):                  <div className="flex justify-center items-center min-h-screen">
                    <div className="loader "></div>
                  </div>
                  }
              {blogs?.results?.youtube_video?.length > 0 && (
                <div className="">
                  <div className=" flex w-full justify-between flex-wrap   mb-4 mt-20 text-black">
                    <h2 className="text-homeblack border-b-2 border-pink mb-1">
                      Latest Videos for Digital marketing Success
                    </h2>
                    <Link href={`https://www.youtube.com/@W3eradigital`} className="lg:mt-0 mt-4" target="_blank">
                      <Button content="View All" />
                    </Link>
                  </div>
                  <div className="w-full flex justify-between flex-wrap gap-3">
                    {blogs?.results?.youtube_video?.length > 0 ? (
                      blogs?.results?.youtube_video?.slice(0, 4)?.map((elem: any, index: number) => (
                        <Link href={elem?.url} key={index} className="w-full sm:w-[48%] h-full lg:w-[24%]">
                          <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4 flex flex-col justify-between h-[380px]">
                            {elem?.thumbnail && (
                              <Image
                                src={elem?.thumbnail || ""}
                                height={175}
                                unoptimized
                                width={328}
                                alt={elem?.thumbnail_alt}
                                className="w-full "
                              />
                            )}
                            <div className="flex flex-col ml-4 items-start gap-2 flex-grow">
                              <p className="text-[18px] text-homeblack mt-4 group-hover:text-blue font-medium blog-title">
                                {elem?.title}
                              </p>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <p>No blogs available.</p>
                    )}
                  </div>
                </div>
              )}
              {category?.map((elem: any, index: number) => (
                <div key={index} className="mt-12">
                  <div className="flex items-center justify-between">
                    <div className="border-b-2 border-pink w-fit mb-4  text-black">
                      {elem?.category_name == "SEM" && (
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Search Engine Marketing Tips</h2>
                      )}
                      {elem?.category_name == "Google Updates" && (
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Google Updates</h2>
                      )}
                      {elem?.category_name == "SEO" && (
                        <h2 className="text-homeblack mb-1"> W3era Blogs:Top SEO Insights</h2>
                      )}
                    </div>
                    <Link href={`/blog/${elem?.category_slug}`}>
                      <Button content="View All" />
                    </Link>
                  </div>
                  <div className="w-full flex justify-between flex-wrap gap-3">
                    {elem?.blogs?.length > 0 ? (
                      elem?.blogs.slice(0, 4).map((blog: any, blogIndex: number) => (
                        <Link
                          href={`/blog/${blog?.category?.category_slug}/${blog?.slug_link}`}
                          key={blogIndex}
                          className="w-full sm:w-[48%] h-inherit lg:w-[24%]"
                        >
                          <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4 sm:text-left items-start gap-2 flex flex-col h-full">
                            {blog?.image && (
                              <Image
                                src={blog?.image || ""}
                                height={175}
                                width={328}
                                unoptimized
                                alt={blog?.image_alt || "Blog Image"}
                                className="w-full"
                              />
                            )}
                            <div className="flex flex-col ml-4 items-start gap-2">
                              <p className="text-[20px] text-homeblack mt-4 group-hover:text-blue font-bold blog-title">
                                {blog?.title}
                              </p>
                              <p className="text-homegrey text-[18px]">
                                <Link href={`/blog/${blog?.category?.category_slug}`}>
                                  <span className="text-blue font-medium">
                                    {blog?.category?.name || "Uncategorized"}
                                  </span>{" "}
                                </Link>
                              </p>
                              <div className="flex justify-between items-center mt-4 w-full text-homegrey">
                                <div className="flex items-center gap-2">
                                  <CiClock2 className="w-4 h-4" />
                                  {blog?.reading_time && <span>{blog?.reading_time} min read</span>}
                                </div>
                                <span>{blog?.blog_date || ""}</span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <p>No blogs available.</p>
                    )}
                  </div>
                </div>
              ))}
              {recentnews && recentnews.length > 0 && (
                <div className="mt-12">
                  <div className=" flex justify-between items-center">
                    <h2 className="text-homeblack mb-1 border-b-2 border-pink w-fit">Latest News</h2>
                    <p>
                      <Link href={`/news`}>
                        <Button content="View All" />
                      </Link>
                    </p>
                  </div>
                  <div className="w-full flex justify-between flex-wrap gap-3">
                    {recentnews.slice(0, 4).map((elem: any, index: number) => (
                      <Link
                        href={`/news/${elem?.category?.category_slug}/${elem?.slug_link}`}
                        key={index}
                        className="w-full sm:w-[48%] lg:w-[24%]"
                      >
                        <div className="bg-white border-[1px] group border-slate-200 rounded-lg my-4 w-full p-4 flex flex-col h-full">
                          {elem?.image && (
                            <Image
                              src={elem?.image || ""}
                              height={175}
                              width={328}
                              unoptimized
                              alt={elem?.image_alt}
                              className="w-full"
                            />
                          )}
                          <div className="flex flex-col ml-4 mt-4 items-start gap-2">
                            <p className="text-[18px] text-homeblack group-hover:text-blue font-bold blog-title">
                              {elem?.title}
                            </p>
                            <p className="text-homegrey text-[16px]">
                              <Link href={`/news/${elem?.category?.category_slug}`}>
                                <span className="text-blue font-medium">
                                  {elem?.category?.name || "Uncategorized"}
                                </span>{" "}
                              </Link>
                            </p>
                            <div className="flex justify-between items-center mt-4 w-full text-homegrey">
                              <div className="flex items-center gap-2">
                                <CiClock2 className="w-4 h-4" />
                                {elem?.reading_time && <span>{elem?.reading_time} min read</span>}
                              </div>
                              <span>{elem?.blog_date || ""}</span>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <NewsLetter />
        </div>
      </div>
    </div>
  )
}

export default Blogs
